import React, { useEffect, useRef, useState } from "react";
import Apiservice from "../Apiservice";
import { formatDate } from '../Utils/Utils';
import EoccurrenceReportPDF from "./EoccurrencePDF";
import { PDFDownloadLink } from "@react-pdf/renderer";

const EoccurrenceReport = () => {
    const [eoccurrences, setEOccurrences] = useState([]);
    const [sites, setSites] = useState([]);

    const [siteId, setSiteId] = useState("");
    const [particularDate, setParticularDate] = useState("");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [timeFrom, setTimeFrom] = useState("");
    const [timeTo, setTimeTo] = useState("");
    const subjectRef = useRef("");

    const fetchData = async () => {
        let data = {
            siteId,
            date: particularDate,
            dateFrom,
            dateTo,
            timeFrom,
            timeTo,
            subject: subjectRef.current.value,
            status: 0,
        };

        let result = await Apiservice.OccurrenceListPage(data);
        console.log("result", result)
        if (result.success === true) {
            const retrievedOccurrences = result.data;
            setEOccurrences(retrievedOccurrences.enrichedOccurrences || []);
        } else {
            alert(result.message);
        }
    };

    useEffect(() => {
        const fetchSites = async () => {
            let result = await Apiservice.AllSites({ status: 0 });
            if (result.success === true) {
                setSites(result.data || []);
            } else {
                alert(result.message);
            }
        };
        fetchSites();
    }, []);
    console.log("eoccurrences", eoccurrences)

    return (
        <div className="container-fluid card shadow p-2 m-2">
            <div className="card shadow p-2 m-2">
                {/* <h4 className="mb-3">E-Occurrence Report</h4> */}

                {/* Filters */}
                <div className="row mb-2">
                    <label className="col-2 col-form-label">Site</label>
                    <div className="col-5">
                        <select
                            className="form-control form-control-sm form-select form-select-sm"
                            value={siteId}
                            onChange={(e) => setSiteId(e.target.value)}
                        >
                            <option value="">Select Site</option>
                            {sites.length > 0 ? (
                                sites.map((site) => (
                                    <option value={site.id} key={site.id}>
                                        {site.name}
                                    </option>
                                ))
                            ) : (
                                <option value="">No Site Available</option>
                            )}
                        </select>
                    </div>
                    <label className="col-2 col-form-label">Particular Date</label>
                    <div className="col-3">
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            value={particularDate}
                            onChange={(e) => setParticularDate(e.target.value)}
                        />
                    </div>
                </div>

                <div className="row mb-2">
                    <label className="col-2 col-form-label">From Date</label>
                    <div className="col-4">
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            value={dateFrom}
                            onChange={(e) => setDateFrom(e.target.value)}
                        />
                    </div>

                    <label className="col-2 col-form-label">To Date</label>
                    <div className="col-4">
                        <input
                            type="date"
                            className="form-control form-control-sm"
                            value={dateTo}
                            onChange={(e) => setDateTo(e.target.value)}
                        />
                    </div>
                </div>

                <div className="row mb-2">
                    <label className="col-2 col-form-label">From Time</label>
                    <div className="col-4">
                        <input
                            type="time"
                            className="form-control form-control-sm"
                            value={timeFrom}
                            onChange={(e) => setTimeFrom(e.target.value)}
                        />
                    </div>

                    <label className="col-2 col-form-label">To Time</label>
                    <div className="col-4">
                        <input
                            type="time"
                            className="form-control form-control-sm"
                            value={timeTo}
                            onChange={(e) => setTimeTo(e.target.value)}
                        />
                    </div>
                </div>

                <div className="row mb-3">
                    <label className="col-2 col-form-label">Subject</label>
                    <div className="col-10">
                        <input
                            type="text"
                            ref={subjectRef}
                            className="form-control form-control-sm"
                            placeholder="Enter subject"
                        />
                    </div>
                </div>

                <div className="text-end">
                    <button className="btn btn-sm btn-primary me-2" onClick={fetchData}>
                        Search
                    </button>
                    <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => setEOccurrences([])}
                    >
                        Reset
                    </button>
                </div>
            </div>
            {
                eoccurrences.length > 0 && (
                    <div className="row">
                        <div className="col-2">
                            <div className="mt-2">
                                <PDFDownloadLink
                                    document={<EoccurrenceReportPDF eoccurrences={eoccurrences}
                                        siteId={siteId} particularDate={particularDate} dateFrom={dateFrom}
                                        dateTo={dateTo} timeFrom={timeFrom} timeTo={timeTo}
                                        subjectRef={subjectRef.current.value} />}
                                    fileName="E_Occurrence_Report.pdf"
                                    className="btn btn-success btn-sm"
                                >
                                    {({ loading }) => (loading ? "Preparing PDF..." : "Download PDF")}
                                </PDFDownloadLink>
                            </div>
                        </div>
                    </div>
                )
            }


            {/* Report Table */}
            <div className="row card shadow p-2 m-2">
                <div className="col table-responsive">
                    <table className="table table-bordered table-sm">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Date</th>
                                <th>Staff</th>
                                <th>Time</th>
                                <th>Subject</th>
                                <th>Occurrence</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(() => {
                                if (!Array.isArray(eoccurrences) || eoccurrences.length === 0) {
                                    return (
                                        <tr>
                                            <td colSpan={6} className="text-center">No Data Found</td>
                                        </tr>
                                    );
                                }

                                // --- helpers ---
                                // const getDateKey = (occ) => {
                                //     if (!occ?.date) return "-";
                                //     return occ.date.includes("T") ? occ.date.split("T")[0] : occ.date;
                                // };
                                const getDateKey = (occ) => {
                                    if (!occ?.date) return "-";

                                    const d = new Date(occ.date);
                                    return d.toLocaleDateString("en-CA", {
                                        timeZone: "Asia/Kolkata"
                                    });
                                };
                                const getUserObj = (occ) => {
                                    const ud = occ?.userDetails;
                                    if (!ud) return null;
                                    if (Array.isArray(ud)) return ud[0] || null;
                                    return ud; // already an object
                                };

                                const getUserDisplay = (occ) => {
                                    const u = getUserObj(occ);
                                    if (!u) return occ.userId ?? "-";
                                    const name = `${u.firstName ?? ""} ${u.lastName ?? ""}`.trim();
                                    return name || occ.userId || "-";
                                };

                                // const formatDateKey = (dateKey) => {
                                //     if (!dateKey || dateKey === "-") return "-";
                                //     const [y, m, d] = dateKey.split("-");
                                //     return d && m && y ? `${d}-${m}-${y}` : dateKey;
                                // };

                                const formatDateKey = (dateKey) => {
                                    if (!dateKey || dateKey === "-") return "-";
                                    const [y, m, d] = dateKey.split("-");
                                    return d && m && y ? `${d}-${m}-${y}` : dateKey;
                                };

                                // sort so equal dates/staff become contiguous (optional)
                                // const rows = [...eoccurrences].sort((a, b) => {
                                //     const da = getDateKey(a);
                                //     const db = getDateKey(b);
                                //     if (da !== db) return new Date(da) - new Date(db);

                                //     const ua = getUserDisplay(a);
                                //     const ub = getUserDisplay(b);
                                //     if (ua !== ub) return ua.localeCompare(ub);

                                //     const ta = a.time ?? "";
                                //     const tb = b.time ?? "";
                                //     return ta.localeCompare(tb);
                                // });

                                const rows = [...eoccurrences].sort((a, b) => {
                                    const da = getDateKey(a);
                                    const db = getDateKey(b);

                                    if (da !== db) return da.localeCompare(db);

                                    const ua = getUserDisplay(a);
                                    const ub = getUserDisplay(b);
                                    if (ua !== ub) return ua.localeCompare(ub);

                                    const ta = a.time ?? "";
                                    const tb = b.time ?? "";
                                    return ta.localeCompare(tb);
                                });

                                // --- compute rowSpans for date & staff ---
                                const dateSpans = new Array(rows.length).fill(0);
                                const staffSpans = new Array(rows.length).fill(0);

                                for (let i = 0; i < rows.length;) {
                                    const dateKey = getDateKey(rows[i]);
                                    let j = i + 1;
                                    while (j < rows.length && getDateKey(rows[j]) === dateKey) j++;
                                    dateSpans[i] = j - i;
                                    i = j;
                                }

                                for (let i = 0; i < rows.length;) {
                                    const staffKey = getUserDisplay(rows[i]);
                                    let j = i + 1;
                                    while (j < rows.length && getUserDisplay(rows[j]) === staffKey) j++;
                                    staffSpans[i] = j - i;
                                    i = j;
                                }

                                // --- render ---
                                let rowNumber = 0;
                                return rows.map((occ, idx) => {
                                    rowNumber++;
                                    const dateKey = getDateKey(occ);

                                    return (
                                        <tr key={occ.id ?? `${dateKey}-${idx}`}>
                                            <td>{rowNumber}</td>

                                            {/* Date cell merged */}
                                            {dateSpans[idx] > 0 ? (
                                                <td rowSpan={dateSpans[idx]} className="align-middle text-center">
                                                    {formatDateKey(dateKey)}
                                                </td>
                                            ) : null}

                                            {/* Staff cell merged */}
                                            {staffSpans[idx] > 0 ? (
                                                <td rowSpan={staffSpans[idx]} className="align-middle text-center">
                                                    {getUserDisplay(occ)}
                                                </td>
                                            ) : null}

                                            <td>{occ.time ?? "-"}</td>
                                            <td>{occ.subject ?? "-"}</td>
                                            <td>{occ.occurrence ?? "-"}</td>
                                        </tr>
                                    );
                                });
                            })()}
                        </tbody>

                    </table>
                </div>
            </div>
        </div >
    );
};

export default EoccurrenceReport;
